import { application } from "./application";
import { registerControllers } from "stimulus-vite-helpers";

registerControllers(
  application,
  import.meta.glob("./**/*_controller.js", { eager: true }),
);
